module.exports = __webpack_public_path__ + "static/media/instruction-photo-one@2x.2735dc41.png";